import { getAdminToken } from "./auth";

export const DATA_CHANGED_EVENT = "admin-data-changed";

const baseURL = process.env.REACT_APP_API_BASE_URL || window.__ENV__?.API_BASE_URL || "";

export async function request<T>(path: string, options: RequestInit = {}): Promise<T> {
  const token = getAdminToken();
  const response = await fetch(`${baseURL}${path}`, {
    ...options,
    headers: {
      ...(options.body && !(options.body instanceof FormData)
        ? { "Content-Type": "application/json" }
        : {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
  });
  const body: unknown = response.headers.get("content-type")?.includes("application/json")
    ? await response.json()
    : null;
  if (!response.ok) {
    if (response.status === 401) localStorage.removeItem("admin-token");
    const message =
      typeof body === "object" && body !== null && "error" in body
        ? String(body.error)
        : "Request failed";
    throw new Error(message);
  }
  const method = (options.method || "GET").toUpperCase();
  if (method !== "GET" && method !== "HEAD") {
    window.dispatchEvent(new Event(DATA_CHANGED_EVENT));
  }
  return body as T;
}

export async function revokeSession(token: string): Promise<void> {
  const response = await fetch(`${baseURL}/api/auth/logout`, {
    method: "POST",
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!response.ok) throw new Error("Could not revoke session");
}

export function exportURL(dataset: string): string {
  return `${baseURL}/api/admin/exports/${dataset}`;
}
